/* helper.ts */

/* Constants */
import { Status } from "src/shared/constants/admin-dashboard/Settings";

export const mapStatusToColor = (status: Status) => {
  switch (status) {
    case Status.DEVELOPMENT:
      return "var(--ion-color-editing)";
  }
};
